import React, { useRef } from "react";
import styled from "styled-components";
import { InputGroup } from "@blueprintjs/core";

import { CopyButton } from "@components/CopyButton";

interface Props {
  shareLink?: string;
  focus?: boolean;
}

const ButtonContainer = styled.div`
  margin-top: 6px;
  margin-right: 8px;
`;

export const ShareLink: React.FC<Props> = ({ shareLink, focus }) => {
  const inputRef = useRef(null);

  return (
    <InputGroup
      inputRef={inputRef}
      value={shareLink || "loading..."}
      // readOnly={true} ruins the styling... therefore:
      onChange={() => {}} // do nothing :)
      autoFocus={focus ?? true}
      fill={true}
      onFocus={(e: React.FocusEvent<HTMLInputElement>) => e.target.select()}
      rightElement={
        <ButtonContainer>
          <CopyButton getTarget={() => inputRef.current} />
        </ButtonContainer>
      }
    />
  );
};
